"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * development API of Digital Villages Platform
 * See digitale-doerfer-api.json (info.description) for more details
 *
 * The version of the OpenAPI document: See digitale-doerfer-api.json
 * Contact: support@digitale-doerfer.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 * no description
 */
class GrapevineGroupEventsApi extends runtime.BaseAPI {
    /**
     * This action can only be done by membership admins of the group.  ---  ## Authenticated via one time token  Authorization is done via mail token  ## Potential Exceptions  |Type|Status Code|Description| | ---- | ---- | ---- | |`GROUP_NOT_FOUND`|404 NOT_FOUND|The requested group does not exist| | ― | ― | ― | |`EVENT_ATTRIBUTE_INVALID`|400 BAD_REQUEST|An attribute of the provided event is not valid|
     * Accept a pending group join request that was requested via mail 🔐 one time token
     */
    acceptPendingGroupJoinRequestMailUsingPOSTRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.acceptingPersonId === null || requestParameters.acceptingPersonId === undefined) {
                throw new runtime.RequiredError('acceptingPersonId', 'Required parameter requestParameters.acceptingPersonId was null or undefined when calling acceptPendingGroupJoinRequestMailUsingPOST.');
            }
            if (requestParameters.mailToken === null || requestParameters.mailToken === undefined) {
                throw new runtime.RequiredError('mailToken', 'Required parameter requestParameters.mailToken was null or undefined when calling acceptPendingGroupJoinRequestMailUsingPOST.');
            }
            if (requestParameters.clientRequest === null || requestParameters.clientRequest === undefined) {
                throw new runtime.RequiredError('clientRequest', 'Required parameter requestParameters.clientRequest was null or undefined when calling acceptPendingGroupJoinRequestMailUsingPOST.');
            }
            const queryParameters = {};
            if (requestParameters.acceptingPersonId !== undefined) {
                queryParameters['acceptingPersonId'] = requestParameters.acceptingPersonId;
            }
            if (requestParameters.mailToken !== undefined) {
                queryParameters['mailToken'] = requestParameters.mailToken;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.apiKey !== undefined && requestParameters.apiKey !== null) {
                headerParameters['apiKey'] = String(requestParameters.apiKey);
            }
            if (requestParameters.appVariantIdentifier !== undefined && requestParameters.appVariantIdentifier !== null) {
                headerParameters['appVariantIdentifier'] = String(requestParameters.appVariantIdentifier);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("Auth0", ["openid"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer Token authentication
            }
            const response = yield this.request({
                path: `/grapevine/group/event/groupPendingJoinAcceptRequest/mail`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ClientGroupPendingJoinAcceptRequestToJSON(requestParameters.clientRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ClientGroupPendingJoinAcceptConfirmationFromJSON(jsonValue));
        });
    }
    /**
     * This action can only be done by membership admins of the group.  ---  ## Authenticated via one time token  Authorization is done via mail token  ## Potential Exceptions  |Type|Status Code|Description| | ---- | ---- | ---- | |`GROUP_NOT_FOUND`|404 NOT_FOUND|The requested group does not exist| | ― | ― | ― | |`EVENT_ATTRIBUTE_INVALID`|400 BAD_REQUEST|An attribute of the provided event is not valid|
     * Accept a pending group join request that was requested via mail 🔐 one time token
     */
    acceptPendingGroupJoinRequestMailUsingPOST(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.acceptPendingGroupJoinRequestMailUsingPOSTRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * This action can only be done by membership admins of the group.  ---  ## Authenticated via OAuth 2.0    ### Required Roles |Key|Related Entity Class|Name|Description| | ---- | ---- | ---- | ---- | |`GROUP_MEMBERSHIP_ADMIN`|`Group`|Gruppenmitglied-Admin|Erhält Benachrichtigungen über ausstehende Gruppenbeitrittsanfragen. Kann Anträge auf Gruppenmitgliedschaft annehmen oder ablehnen.|  ## Potential Exceptions  |Type|Status Code|Description| | ---- | ---- | ---- | |`GROUP_NOT_FOUND`|404 NOT_FOUND|The requested group does not exist| | ― | ― | ― | |`EVENT_ATTRIBUTE_INVALID`|400 BAD_REQUEST|An attribute of the provided event is not valid| |`NOT_AUTHORIZED`|403 FORBIDDEN|The user is not authorized to do this action or view the data| |`PERSON_WITH_OAUTH_ID_NOT_FOUND`|404 NOT_FOUND|No person exists with the given OAuth ID|
     * Accept a pending group join request 🔒 oauth2
     */
    acceptPendingGroupJoinRequestUsingPOSTRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.clientRequest === null || requestParameters.clientRequest === undefined) {
                throw new runtime.RequiredError('clientRequest', 'Required parameter requestParameters.clientRequest was null or undefined when calling acceptPendingGroupJoinRequestUsingPOST.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.apiKey !== undefined && requestParameters.apiKey !== null) {
                headerParameters['apiKey'] = String(requestParameters.apiKey);
            }
            if (requestParameters.appVariantIdentifier !== undefined && requestParameters.appVariantIdentifier !== null) {
                headerParameters['appVariantIdentifier'] = String(requestParameters.appVariantIdentifier);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("Auth0", ["openid"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer Token authentication
            }
            const response = yield this.request({
                path: `/grapevine/group/event/groupPendingJoinAcceptRequest`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ClientGroupPendingJoinAcceptRequestToJSON(requestParameters.clientRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ClientGroupPendingJoinAcceptConfirmationFromJSON(jsonValue));
        });
    }
    /**
     * This action can only be done by membership admins of the group.  ---  ## Authenticated via OAuth 2.0    ### Required Roles |Key|Related Entity Class|Name|Description| | ---- | ---- | ---- | ---- | |`GROUP_MEMBERSHIP_ADMIN`|`Group`|Gruppenmitglied-Admin|Erhält Benachrichtigungen über ausstehende Gruppenbeitrittsanfragen. Kann Anträge auf Gruppenmitgliedschaft annehmen oder ablehnen.|  ## Potential Exceptions  |Type|Status Code|Description| | ---- | ---- | ---- | |`GROUP_NOT_FOUND`|404 NOT_FOUND|The requested group does not exist| | ― | ― | ― | |`EVENT_ATTRIBUTE_INVALID`|400 BAD_REQUEST|An attribute of the provided event is not valid| |`NOT_AUTHORIZED`|403 FORBIDDEN|The user is not authorized to do this action or view the data| |`PERSON_WITH_OAUTH_ID_NOT_FOUND`|404 NOT_FOUND|No person exists with the given OAuth ID|
     * Accept a pending group join request 🔒 oauth2
     */
    acceptPendingGroupJoinRequestUsingPOST(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.acceptPendingGroupJoinRequestUsingPOSTRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * This action can only be done by membership admins of the group.  ---  ## Authenticated via one time token  Authorization is done via mail token  ## Potential Exceptions  |Type|Status Code|Description| | ---- | ---- | ---- | |`GROUP_NOT_FOUND`|404 NOT_FOUND|The requested group does not exist| | ― | ― | ― | |`EVENT_ATTRIBUTE_INVALID`|400 BAD_REQUEST|An attribute of the provided event is not valid|
     * Deny a pending group join request that was requested via mail 🔐 one time token
     */
    denyPendingGroupJoinRequestMailUsingPOSTRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.denyingPersonId === null || requestParameters.denyingPersonId === undefined) {
                throw new runtime.RequiredError('denyingPersonId', 'Required parameter requestParameters.denyingPersonId was null or undefined when calling denyPendingGroupJoinRequestMailUsingPOST.');
            }
            if (requestParameters.mailToken === null || requestParameters.mailToken === undefined) {
                throw new runtime.RequiredError('mailToken', 'Required parameter requestParameters.mailToken was null or undefined when calling denyPendingGroupJoinRequestMailUsingPOST.');
            }
            if (requestParameters.clientRequest === null || requestParameters.clientRequest === undefined) {
                throw new runtime.RequiredError('clientRequest', 'Required parameter requestParameters.clientRequest was null or undefined when calling denyPendingGroupJoinRequestMailUsingPOST.');
            }
            const queryParameters = {};
            if (requestParameters.denyingPersonId !== undefined) {
                queryParameters['denyingPersonId'] = requestParameters.denyingPersonId;
            }
            if (requestParameters.mailToken !== undefined) {
                queryParameters['mailToken'] = requestParameters.mailToken;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.apiKey !== undefined && requestParameters.apiKey !== null) {
                headerParameters['apiKey'] = String(requestParameters.apiKey);
            }
            if (requestParameters.appVariantIdentifier !== undefined && requestParameters.appVariantIdentifier !== null) {
                headerParameters['appVariantIdentifier'] = String(requestParameters.appVariantIdentifier);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("Auth0", ["openid"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer Token authentication
            }
            const response = yield this.request({
                path: `/grapevine/group/event/groupPendingJoinDenyRequest/mail`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ClientGroupPendingJoinDenyRequestToJSON(requestParameters.clientRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ClientGroupPendingJoinDenyConfirmationFromJSON(jsonValue));
        });
    }
    /**
     * This action can only be done by membership admins of the group.  ---  ## Authenticated via one time token  Authorization is done via mail token  ## Potential Exceptions  |Type|Status Code|Description| | ---- | ---- | ---- | |`GROUP_NOT_FOUND`|404 NOT_FOUND|The requested group does not exist| | ― | ― | ― | |`EVENT_ATTRIBUTE_INVALID`|400 BAD_REQUEST|An attribute of the provided event is not valid|
     * Deny a pending group join request that was requested via mail 🔐 one time token
     */
    denyPendingGroupJoinRequestMailUsingPOST(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.denyPendingGroupJoinRequestMailUsingPOSTRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * This action can only be done by membership admins of the group.  ---  ## Authenticated via OAuth 2.0    ### Required Roles |Key|Related Entity Class|Name|Description| | ---- | ---- | ---- | ---- | |`GROUP_MEMBERSHIP_ADMIN`|`Group`|Gruppenmitglied-Admin|Erhält Benachrichtigungen über ausstehende Gruppenbeitrittsanfragen. Kann Anträge auf Gruppenmitgliedschaft annehmen oder ablehnen.|  ## Potential Exceptions  |Type|Status Code|Description| | ---- | ---- | ---- | |`GROUP_NOT_FOUND`|404 NOT_FOUND|The requested group does not exist| | ― | ― | ― | |`EVENT_ATTRIBUTE_INVALID`|400 BAD_REQUEST|An attribute of the provided event is not valid| |`NOT_AUTHORIZED`|403 FORBIDDEN|The user is not authorized to do this action or view the data| |`PERSON_WITH_OAUTH_ID_NOT_FOUND`|404 NOT_FOUND|No person exists with the given OAuth ID|
     * Deny a pending group join request 🔒 oauth2
     */
    denyPendingGroupJoinRequestUsingPOSTRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.clientRequest === null || requestParameters.clientRequest === undefined) {
                throw new runtime.RequiredError('clientRequest', 'Required parameter requestParameters.clientRequest was null or undefined when calling denyPendingGroupJoinRequestUsingPOST.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.apiKey !== undefined && requestParameters.apiKey !== null) {
                headerParameters['apiKey'] = String(requestParameters.apiKey);
            }
            if (requestParameters.appVariantIdentifier !== undefined && requestParameters.appVariantIdentifier !== null) {
                headerParameters['appVariantIdentifier'] = String(requestParameters.appVariantIdentifier);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("Auth0", ["openid"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer Token authentication
            }
            const response = yield this.request({
                path: `/grapevine/group/event/groupPendingJoinDenyRequest`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ClientGroupPendingJoinDenyRequestToJSON(requestParameters.clientRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ClientGroupPendingJoinDenyConfirmationFromJSON(jsonValue));
        });
    }
    /**
     * This action can only be done by membership admins of the group.  ---  ## Authenticated via OAuth 2.0    ### Required Roles |Key|Related Entity Class|Name|Description| | ---- | ---- | ---- | ---- | |`GROUP_MEMBERSHIP_ADMIN`|`Group`|Gruppenmitglied-Admin|Erhält Benachrichtigungen über ausstehende Gruppenbeitrittsanfragen. Kann Anträge auf Gruppenmitgliedschaft annehmen oder ablehnen.|  ## Potential Exceptions  |Type|Status Code|Description| | ---- | ---- | ---- | |`GROUP_NOT_FOUND`|404 NOT_FOUND|The requested group does not exist| | ― | ― | ― | |`EVENT_ATTRIBUTE_INVALID`|400 BAD_REQUEST|An attribute of the provided event is not valid| |`NOT_AUTHORIZED`|403 FORBIDDEN|The user is not authorized to do this action or view the data| |`PERSON_WITH_OAUTH_ID_NOT_FOUND`|404 NOT_FOUND|No person exists with the given OAuth ID|
     * Deny a pending group join request 🔒 oauth2
     */
    denyPendingGroupJoinRequestUsingPOST(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.denyPendingGroupJoinRequestUsingPOSTRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Depending on the group accessibility settings the user is member immediately or requires approval.If the membership status is APPROVED or REJECTED the existing membership is returned. If the status is PENDING a GROUP_MEMBERSHIP_ALREADY_PENDING error is returned.  ---  ## Authenticated via OAuth 2.0  Parameter **`appVariantIdentifier`** or **`apiKey`** or oauth client in access token is required  ## Potential Exceptions  |Type|Status Code|Description| | ---- | ---- | ---- | |`GROUP_NOT_FOUND`|404 NOT_FOUND|The requested group does not exist| |`GROUP_MEMBERSHIP_ALREADY_PENDING`|409 CONFLICT|The person already requested to join the group and was not yet approved. <br/> (The group membership status is already PENDING)| | ― | ― | ― | |`EVENT_ATTRIBUTE_INVALID`|400 BAD_REQUEST|An attribute of the provided event is not valid| |`NOT_AUTHORIZED`|403 FORBIDDEN|The user is not authorized to do this action or view the data| |`APP_VARIANT_NOT_FOUND`|404 NOT_FOUND|The requested app variant does not exist| |`PERSON_WITH_OAUTH_ID_NOT_FOUND`|404 NOT_FOUND|No person exists with the given OAuth ID|
     * Request to join a group 🔒 oauth2
     */
    joinGroupUsingPOSTRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.clientRequest === null || requestParameters.clientRequest === undefined) {
                throw new runtime.RequiredError('clientRequest', 'Required parameter requestParameters.clientRequest was null or undefined when calling joinGroupUsingPOST.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.apiKey !== undefined && requestParameters.apiKey !== null) {
                headerParameters['apiKey'] = String(requestParameters.apiKey);
            }
            if (requestParameters.appVariantIdentifier !== undefined && requestParameters.appVariantIdentifier !== null) {
                headerParameters['appVariantIdentifier'] = String(requestParameters.appVariantIdentifier);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("Auth0", ["openid"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer Token authentication
            }
            const response = yield this.request({
                path: `/grapevine/group/event/groupJoinRequest`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ClientGroupJoinRequestToJSON(requestParameters.clientRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ClientGroupJoinConfirmationFromJSON(jsonValue));
        });
    }
    /**
     * Depending on the group accessibility settings the user is member immediately or requires approval.If the membership status is APPROVED or REJECTED the existing membership is returned. If the status is PENDING a GROUP_MEMBERSHIP_ALREADY_PENDING error is returned.  ---  ## Authenticated via OAuth 2.0  Parameter **`appVariantIdentifier`** or **`apiKey`** or oauth client in access token is required  ## Potential Exceptions  |Type|Status Code|Description| | ---- | ---- | ---- | |`GROUP_NOT_FOUND`|404 NOT_FOUND|The requested group does not exist| |`GROUP_MEMBERSHIP_ALREADY_PENDING`|409 CONFLICT|The person already requested to join the group and was not yet approved. <br/> (The group membership status is already PENDING)| | ― | ― | ― | |`EVENT_ATTRIBUTE_INVALID`|400 BAD_REQUEST|An attribute of the provided event is not valid| |`NOT_AUTHORIZED`|403 FORBIDDEN|The user is not authorized to do this action or view the data| |`APP_VARIANT_NOT_FOUND`|404 NOT_FOUND|The requested app variant does not exist| |`PERSON_WITH_OAUTH_ID_NOT_FOUND`|404 NOT_FOUND|No person exists with the given OAuth ID|
     * Request to join a group 🔒 oauth2
     */
    joinGroupUsingPOST(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.joinGroupUsingPOSTRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * A user can leave a group any time. Depending on the group accessibility settings the user might require approval on re-joining the group.  ---  ## Authenticated via OAuth 2.0  Parameter **`appVariantIdentifier`** or **`apiKey`** or oauth client in access token is required  ## Potential Exceptions  |Type|Status Code|Description| | ---- | ---- | ---- | |`GROUP_NOT_FOUND`|404 NOT_FOUND|The requested group does not exist| |`NOT_MEMBER_OF_GROUP`|409 CONFLICT|The user is not a member of the group| | ― | ― | ― | |`EVENT_ATTRIBUTE_INVALID`|400 BAD_REQUEST|An attribute of the provided event is not valid| |`NOT_AUTHORIZED`|403 FORBIDDEN|The user is not authorized to do this action or view the data| |`APP_VARIANT_NOT_FOUND`|404 NOT_FOUND|The requested app variant does not exist| |`PERSON_WITH_OAUTH_ID_NOT_FOUND`|404 NOT_FOUND|No person exists with the given OAuth ID|
     * Request to leave a group 🔒 oauth2
     */
    leaveGroupUsingPOSTRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.clientRequest === null || requestParameters.clientRequest === undefined) {
                throw new runtime.RequiredError('clientRequest', 'Required parameter requestParameters.clientRequest was null or undefined when calling leaveGroupUsingPOST.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.apiKey !== undefined && requestParameters.apiKey !== null) {
                headerParameters['apiKey'] = String(requestParameters.apiKey);
            }
            if (requestParameters.appVariantIdentifier !== undefined && requestParameters.appVariantIdentifier !== null) {
                headerParameters['appVariantIdentifier'] = String(requestParameters.appVariantIdentifier);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("Auth0", ["openid"]);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer Token authentication
            }
            const response = yield this.request({
                path: `/grapevine/group/event/groupLeaveRequest`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ClientGroupLeaveRequestToJSON(requestParameters.clientRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ClientGroupLeaveConfirmationFromJSON(jsonValue));
        });
    }
    /**
     * A user can leave a group any time. Depending on the group accessibility settings the user might require approval on re-joining the group.  ---  ## Authenticated via OAuth 2.0  Parameter **`appVariantIdentifier`** or **`apiKey`** or oauth client in access token is required  ## Potential Exceptions  |Type|Status Code|Description| | ---- | ---- | ---- | |`GROUP_NOT_FOUND`|404 NOT_FOUND|The requested group does not exist| |`NOT_MEMBER_OF_GROUP`|409 CONFLICT|The user is not a member of the group| | ― | ― | ― | |`EVENT_ATTRIBUTE_INVALID`|400 BAD_REQUEST|An attribute of the provided event is not valid| |`NOT_AUTHORIZED`|403 FORBIDDEN|The user is not authorized to do this action or view the data| |`APP_VARIANT_NOT_FOUND`|404 NOT_FOUND|The requested app variant does not exist| |`PERSON_WITH_OAUTH_ID_NOT_FOUND`|404 NOT_FOUND|No person exists with the given OAuth ID|
     * Request to leave a group 🔒 oauth2
     */
    leaveGroupUsingPOST(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.leaveGroupUsingPOSTRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.GrapevineGroupEventsApi = GrapevineGroupEventsApi;
